import React from "react";
import { Phone, Mail, MapPin, Clock, CheckCircle2 } from "lucide-react";
import FooterPage from "../Footer/Sections/Footer";
import { Button, Input, Select } from "antd";
import { PhoneOutlined, MailOutlined } from "@ant-design/icons";

const { Option } = Select;

const ContactPage = () => {
  const features = [
    {
      icon: (
        <CheckCircle2
          style={{ width: "20px", height: "20px", color: "green" }}
        />
      ),
      title: "Free Consultation",
      description: "Get expert advice on your travel needs",
    },
    {
      icon: <Clock style={{ width: "20px", height: "20px", color: "blue" }} />,
      title: "Quick Response",
      description: "We respond to inquiries within 2 hours",
    },
  ];

  return (
    <>
      {/* Hero Section */}
      <section
        style={{
          background: "linear-gradient(to right, #0000ba, #fe0000)",
          padding: "80px 20px",
          textAlign: "center",
          color: "white",
        }}
      >
        <h1
          style={{ fontSize: "40px", fontWeight: "bold", marginBottom: "16px" }}
        >
          Get in Touch
        </h1>
        <p style={{ fontSize: "18px", maxWidth: "600px", margin: "0 auto" }}>
          We're here to help with all your travel needs. Contact us for a free
          consultation.
        </p>
      </section>

      <section style={{ padding: "60px 20px", backgroundColor: "#f9fafb" }}>
        <div
          style={{
            maxWidth: "1200px",
            margin: "0 auto",
            // display: "grid",
            textAlign: "center",
          }}
        >
          <h2
            style={{
              fontSize: "30px",
              fontWeight: "bold",
              marginBottom: "16px",
            }}
          >
            Contact Information
          </h2>
          <p
            style={{
              color: "#4b5563",
              marginBottom: "24px",
              textAlign: "center",
            }}
          >
            Reach out to us for unforgettable travel experiences. We’re
            available 24/7 to assist you with your dream vacations.
          </p>
        </div>
        <div
          style={{
            maxWidth: "1200px",
            margin: "0 auto",
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "40px",
            padding: "20px",
          }}
        >
          <div>
            <div style={{ display: "grid", gap: "16px" }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  background: "white",
                  padding: "16px",
                  borderRadius: "8px",
                  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                }}
              >
                <PhoneOutlined
                  style={{
                    fontSize: "24px",
                    color: "#2563eb",
                    marginRight: "16px",
                  }}
                />
                <div>
                  <h3 style={{ fontWeight: "600" }}>Phone</h3>
                  <p style={{ color: "#4b5563" }}>
                    <a
                      href="tel:+97126422001"
                      style={{ color: "#2563eb", textDecoration: "none" }}
                    >
                      +971(2) 642 2001
                    </a>
                    <br />
                    <a
                      href="tel:+971507220398"
                      style={{ color: "#2563eb", textDecoration: "none" }}
                    >
                      +971 50 722 0398
                    </a>
                  </p>
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  background: "white",
                  padding: "16px",
                  borderRadius: "8px",
                  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                }}
              >
                <MailOutlined
                  style={{
                    fontSize: "24px",
                    color: "#2563eb",
                    marginRight: "16px",
                  }}
                />
                <div>
                  <h3 style={{ fontWeight: "600" }}>Email</h3>
                  <p style={{ color: "#4b5563" }}>info@uphilltravels.ae</p>
                </div>
              </div>
            </div>

            {/* Features */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "16px",
                marginTop: "24px",
              }}
            >
              {features.map((feature, index) => (
                <div
                  key={index}
                  style={{
                    background: "white",
                    padding: "16px",
                    borderRadius: "8px",
                    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: "8px",
                    }}
                  >
                    {feature.icon}
                    <h3 style={{ fontWeight: "600", marginLeft: "8px" }}>
                      {feature.title}
                    </h3>
                  </div>
                  <p style={{ color: "#4b5563", fontSize: "14px" }}>
                    {feature.description}
                  </p>
                </div>
              ))}
            </div>
            <div className="" style={{ marginTop: "24px", borderRadius: 10 }}>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3631.5668963008584!2d54.367!3d24.4973!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5e67c6413a085f%3A0x5e4a6df1d44c5372!2sAl%20Yasat%20Tower!5e0!3m2!1sen!2sae!4v1234567890"
                width="100%"
                height="300"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                className="rounded-lg"
              ></iframe>
            </div>
          </div>

          {/* Contact Form */}
          <div
            style={{
              background: "white",
              padding: "32px",
              borderRadius: "8px",
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            }}
          >
            <h2
              style={{
                fontSize: "24px",
                fontWeight: "bold",
                marginBottom: "16px",
              }}
            >
              Send Us a Message
            </h2>
            <form style={{ display: "grid", gap: "16px" }}>
              <Input
                type="text"
                placeholder="First Name"
                style={{
                  padding: "10px",
                  borderRadius: "6px",
                  border: "1px solid #d1d5db",
                  width: "100%",
                }}
              />
              <Input
                type="text"
                placeholder="Last Name"
                style={{
                  padding: "10px",
                  borderRadius: "6px",
                  border: "1px solid #d1d5db",
                  width: "100%",
                }}
              />
              <Input
                type="email"
                placeholder="Email Address"
                style={{
                  padding: "10px",
                  borderRadius: "6px",
                  border: "1px solid #d1d5db",
                  width: "100%",
                }}
              />
              <Input
                type="tel"
                placeholder="Phone Number"
                style={{
                  padding: "10px",
                  borderRadius: "6px",
                  border: "1px solid #d1d5db",
                  width: "100%",
                }}
              />

              <Select
                style={{ width: "100%", height: "40px" }}
                placeholder="Select Service"
              >
                <Option value="option1">Visa</Option>
                <Option value="option2">Tour</Option>
                <Option value="option3">Air Ticket</Option>
                <Option value="option4">Hotel Booking</Option>
                <Option value="option5">Tour Package</Option>
              </Select>
              <Select
                style={{ width: "100%", height: "40px" }}
                placeholder="No. of Persons"
              >
                <Option value="1">1</Option>
                <Option value="2">2</Option>
                <Option value="3">3</Option>
              </Select>
              <Input.TextArea
                placeholder="Tell us about your travel needs..."
                style={{
                  padding: "10px",
                  borderRadius: "6px",
                  border: "1px solid #d1d5db",
                  width: "100%",
                  minHeight: "100px",
                }}
              ></Input.TextArea>
              <Button
                type="primary"
                style={{
                  background: "#0000ba",
                  color: "white",
                  padding: "12px",
                  borderRadius: "6px",
                  border: "none",
                  cursor: "pointer",
                }}
              >
                Send Message
              </Button>
            </form>
          </div>
        </div>
      </section>

      <FooterPage />
    </>
  );
};

export default ContactPage;
